// extracted by mini-css-extract-plugin
module.exports = {"maximalMobileWidth":"580px","maximalTabletWidth":"1024px","text":"PlaceScreen_text__2cjib","autocomplete":"PlaceScreen_autocomplete__3lA_K"};